import api from '@services/api';

import {
  GET_PROFILE,
  LOGIN,
  LOGOUT,
  RESET_PASSWORD,
  GENERATE_OTP,
  VALIDATE_OTP,
} from './queries';
import {
  IGetProfileResponse,
  ILoginRequest,
  ILoginOtpRequest,
  ILoginValidateOtpRequest,
  ILoginResponse,
  IValidationResponse,
  ILogoutRequest,
  ILogoutResponse,
  IResetPasswordRequest,
  IResetPasswordResponse,
} from '../type';

const AuthApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<ILoginResponse, ILoginRequest>({
      query: (variables) => ({
        document: LOGIN,
        variables,
      }),
      transformResponse: (response: ILoginResponse) => response,
    }),
    loginWithOtp: builder.mutation<ILoginResponse, ILoginOtpRequest>({
      query: (variables) => ({
        document: GENERATE_OTP,
        variables,
      }),
      transformResponse: (response: ILoginResponse) => response,
    }),
    validateOtp: builder.mutation<
      IValidationResponse,
      ILoginValidateOtpRequest
    >({
      query: (variables) => ({
        document: VALIDATE_OTP,
        variables,
      }),
      transformResponse: (response: IValidationResponse) => response,
    }),
    getProfile: builder.query<IGetProfileResponse, void>({
      query: (variables) => ({
        document: GET_PROFILE,
      }),
      transformResponse: (response: IGetProfileResponse) => response,
    }),
    resetPassword: builder.mutation<
      IResetPasswordResponse,
      IResetPasswordRequest
    >({
      query: (variables) => ({
        document: RESET_PASSWORD,
        variables,
      }),
      transformResponse: (response: IResetPasswordResponse) => response,
    }),
    logout: builder.mutation<ILogoutResponse, ILogoutRequest>({
      query: (variables) => ({
        document: LOGOUT,
        variables,
      }),
      transformResponse: (response: ILogoutResponse) => response,
    }),
  }),
});

export const {
  useLoginMutation,
  useLoginWithOtpMutation,
  useValidateOtpMutation,
  useGetProfileQuery,
  useLazyGetProfileQuery,
  useLogoutMutation,
  useResetPasswordMutation,
} = AuthApi;
